import http from "../api/axios-auth-php-frontend";
class RecognitionChallengesService {
    // Get all available challenges
    getAllChallenges() {
        return http.get("recognition-challenges");
    }

    // Get client's enabled challenges with configuration
    getClientChallenges(clientId) {
        return http.get(`recognition-challenges/client/${clientId}`);
    }

    // Configure a single challenge for client
    configureChallenge(data) {
        return http.post("recognition-challenges/client/configure", data);
    }

    // Bulk configure multiple challenges
    bulkConfigureChallenges(data) {
        return http.post("recognition-challenges/client/bulk-configure", data);
    }

    // Toggle challenge enabled/disabled status
    toggleChallengeStatus(clientChallengeId, data) {
        return http.put(`recognition-challenges/client/${clientChallengeId}/toggle`, data);
    }

    getModuleStatus(clientId) {
        return http.get(`recognition-challenges/client/${clientId}/status`);
    }
}

export default new RecognitionChallengesService();